export const DEMAP_INVOICE_ERROR = 'Error While Demapping invoice.'
export const noDataToExportDeliveries = 'No data to export found'
export const REMARKS_REQUIRED = "Remarks should not be empty"
export const MASTERS_MSG = {
    VENDOR : {
        CREATE_SUCCESS :"New vendor is created",
        CREATE_ERROR : "Unable to create new vendor.",
        UPDATE_SUCCESS : 'Vendor is updated.',
        UPDATE_ERROR : "Unable to update vendor."
    },
    BILLING_PARTY_BRANCH : {
        CREATE_SUCCESS : "Billing party branch is created",
        UPDATE_SUCCESS : "Billing party branch is updated."
    }
}
export const FILE_IMPORT = {
    INVALID_FILE : "Invalid file selected.",
    INVALID_FILE_FORMAT : "Invalid file format."
}
export const UPDATE_DISPATCH_LOCATION = {
    SUCCESS : "Updated Dispatch Location!!!",
    ERROR : "Failed To Update Dispatch Location."
}
export const TOAST_MESSAGES = {
    DEMAP_INVOICE_ERROR,
    noDataToExportDeliveries,
    REMARKS_REQUIRED ,
    BOOKING_BRANCH_REQUIRED :'Booking Branch is Required',
    FIELD_REQUIRED : (field) => `${field} is Required`,
    BOOKING_UPDATE_SUCCESS :"Booking updated Successfully!!",
    BOOKING_CREATE_ERROR :"Error while creating booking.",
    BOOKING_CREATE_SUCCESS : "Booking created successfully.",
    CANNOT_EDIT_DEFAULT_RECORDS: "You can't edit default records.",
    ERROR_CAPTCHA_VERIFICATION : "Captcha verification failed, Please try again.",
    REDIRECTING_IN_ORDER_EXPORT : "Redirecting to order report section for downloading data.",
    FILTERS_MESSAGES : {
        NO_FILTERS : "Select any of the filters",
        CREATED_ON_FILTER : "Select both dates for created on filter",
        REQUIRED_ON_FILTER : "Select both dates for required on filter"
    }
}